/* gallery-add-to-list.js  PDP "Add to My Lists" modal.
   Reads the inline product JSON + the live selected variant, then lets the shopper
   save the product into one or more closet lists (window.GLYCloset). Scoped to the
   [data-gly-addlist] trigger + [data-gly-lm] modal host rendered by
   snippets/gallery-add-to-list.liquid. */
(function () {
  'use strict';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var jsonEl = document.querySelector('[data-gly-product-json]');
    var trigger = document.querySelector('[data-gly-addlist]');
    var host = document.querySelector('[data-gly-lm]');
    if (!jsonEl || !trigger || !host || !window.GLYCloset) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!product || !product.variants) return;

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function money(cents) {
      var v = (cents || 0) / 100;
      return '$' + v.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function imgSrc(img) {
      if (!img) return '';
      var s = typeof img === 'string' ? img : (img.src || '');
      if (s.indexOf('//') === 0) s = 'https:' + s;
      return s;
    }
    function optionName(opt) { return (typeof opt === 'string' ? opt : (opt && opt.name)) || ''; }

    /* the variant the buy box currently has selected (falls back to first available) */
    function selectedVariant() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = input && input.value;
      if (id) {
        for (var i = 0; i < product.variants.length; i++) { if (String(product.variants[i].id) === String(id)) return product.variants[i]; }
      }
      for (var j = 0; j < product.variants.length; j++) { if (product.variants[j].available) return product.variants[j]; }
      return product.variants[0];
    }

    function optionValue(variant, wanted) {
      if (!product.options) return '';
      for (var i = 0; i < product.options.length; i++) {
        if (optionName(product.options[i]).toLowerCase() === wanted) return (variant.options || [])[i] || '';
      }
      return '';
    }

    function currentItem() {
      var v = selectedVariant();
      return {
        id: product.id,
        handle: product.handle,
        url: product.url,
        title: product.title,
        image: imgSrc((v && v.featured_image) || product.featured_image || (product.images && product.images[0])),
        price: v ? v.price : product.price,
        compareAt: v ? v.compare_at_price : null,
        variantId: v ? v.id : null,
        color: optionValue(v, 'color'),
        size: optionValue(v, 'size')
      };
    }

    /* ---- trigger label reflects saved state ---- */
    function paintTrigger() {
      var label = trigger.querySelector('[data-gly-addlist-label]');
      var n = window.GLYCloset.listsWithItem(product.id).length;
      if (label) label.textContent = n > 0 ? ('Saved to ' + n + (n === 1 ? ' list' : ' lists') + ' — edit') : 'Add to My Lists';
      trigger.classList.toggle('on', n > 0);
    }

    var creating = false, newName = '';

    function renderModal() {
      var item = currentItem();
      var inLists = window.GLYCloset.listsWithItem(product.id);
      var lists = window.GLYCloset.getLists();
      var meta = [item.color, item.size ? 'Size ' + String(item.size).toUpperCase() : ''].filter(Boolean).join(' · ');

      var html = '';
      html += '<div class="scrim" data-gly-lm-close></div>';
      html += '<div class="listmodal" role="dialog" aria-modal="true">';
      html += '<div class="listmodal__head"><div><div class="listmodal__eyebrow">Save to</div><h2 class="listmodal__title">My Lists</h2></div>';
      html += '<button type="button" class="listmodal__close" data-gly-lm-close aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>';

      html += '<div class="listmodal__item"><div class="listmodal__thumb">' + (item.image ? '<img src="' + esc(item.image) + '" alt="">' : '') + '</div>';
      html += '<div><div class="listmodal__pname">' + esc(item.title) + '</div>' + (meta ? '<div class="listmodal__pmeta">' + esc(meta) + '</div>' : '') + '</div></div>';

      html += '<div class="listmodal__lists">';
      lists.forEach(function (l) {
        var on = inLists.indexOf(l.id) !== -1;
        html += '<button type="button" class="listopt' + (on ? ' on' : '') + '" data-gly-list="' + esc(l.id) + '">';
        html += '<span class="listopt__check' + (on ? ' on' : '') + '">' + (on ? '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' : '') + '</span>';
        html += '<span class="listopt__body"><span class="listopt__name">' + esc(l.name) + '</span><span class="listopt__count">' + l.items.length + (l.items.length === 1 ? ' item' : ' items') + '</span></span>';
        html += '</button>';
      });
      html += '</div>';

      if (creating) {
        html += '<div class="listmodal__create"><input type="text" data-gly-newlist maxlength="60" placeholder="Name your list (e.g. Vacation)" value="' + esc(newName) + '"><button type="button" data-gly-create>Create</button></div>';
      } else if (window.GLYCloset.canCreateList()) {
        html += '<button type="button" class="listmodal__new" data-gly-startcreate><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg> Create a new list</button>';
      } else {
        html += '<p class="listmodal__capnote">You’ve reached the maximum of ' + window.GLYCloset.MAX_LISTS + ' lists.</p>';
      }

      html += '<a class="listmodal__view" href="/pages/my-closet">View My Closet <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></a>';
      html += '</div>';
      host.innerHTML = html;
      var input = host.querySelector('[data-gly-newlist]');
      if (input) { input.focus(); input.setSelectionRange(input.value.length, input.value.length); }
    }

    function open() { creating = false; newName = ''; renderModal(); host.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { host.classList.remove('is-open'); document.body.style.overflow = ''; }

    trigger.addEventListener('click', function (e) { e.preventDefault(); open(); });

    host.addEventListener('click', function (e) {
      if (e.target.closest('[data-gly-lm-close]')) { e.preventDefault(); close(); return; }
      var opt = e.target.closest('[data-gly-list]');
      if (opt) {
        var listId = opt.getAttribute('data-gly-list');
        if (window.GLYCloset.listsWithItem(product.id).indexOf(listId) !== -1) {
          window.GLYCloset.removeItemFromList(listId, product.id);
        } else {
          window.GLYCloset.addItemToList(listId, currentItem());
        }
        renderModal();
        return;
      }
      if (e.target.closest('[data-gly-startcreate]')) { creating = true; renderModal(); return; }
      if (e.target.closest('[data-gly-create]')) { doCreate(); return; }
    });

    host.addEventListener('input', function (e) {
      if (e.target.matches('[data-gly-newlist]')) newName = e.target.value;
    });
    host.addEventListener('keydown', function (e) {
      if (e.target.matches('[data-gly-newlist]') && e.key === 'Enter') { e.preventDefault(); doCreate(); }
    });

    function doCreate() {
      var name = (newName || '').trim();
      if (!name) return;
      var list = window.GLYCloset.createList(name);
      if (!list) { creating = false; newName = ''; renderModal(); return; } // at the list cap
      window.GLYCloset.addItemToList(list.id, currentItem());
      creating = false; newName = '';
      renderModal();
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && host.classList.contains('is-open')) close(); });
    document.addEventListener('gly-closet:change', paintTrigger);

    paintTrigger();
  });
})();
